<script setup lang="ts">
import { h } from 'vue'
import type { IProps } from './Article.types'
import { BLOCKS, type Block } from '@contentful/rich-text-types'
import ContentfulTable from '@/domains/contentful/components/Table/Table.vue'
import ContentfulImage from '@/domains/contentful/components/Image/Image.vue'
import RichTextVueRenderer from '@/domains/contentful/components/RichTextVueRenderer/RichTextVueRenderrer'

const renderNodes = () => ({
  [BLOCKS.TABLE]: (node: Block) => {
    return h(ContentfulTable, {
      data: node,
    })
  },
  [BLOCKS.EMBEDDED_ENTRY]: (node: Block) => {
    if(node.data.target.fields.image) {
      return h(ContentfulImage, {
        data: node,
      })
    }
  },
})

  defineProps<IProps>()
</script>

<template>
  <article
    :id="$t('investor.article.id')"
    class="article"
  >
    <div class="article__container">
      <header class="article__header">
        <time
          v-if="date"
          :datetime="date"
          class="article__date"
        >
          {{ date }}
        </time>
        
        <h1
          v-if="title"
          class="article__title"
        >
          {{ title }}
        </h1>
      </header>
  
      <hr
        class="article__line"
      >
  
      <div class="article__content">
        <RichTextVueRenderer
          class="article__content"
          :node-renderers="renderNodes()"
          :document="content"
        />
      </div>
      
      <slot />
    </div>
  </article>
</template>

<style lang="scss" scoped>
  .article {
    @include section-investor();
 
    &__container {
      @include section-investor__container();
    }

    &__date {
      @include body-2;
      margin-bottom: 1.2rem;
      color: $text-300;
    }

    &__title {
      @include h8;
      margin: auto;
      color: $text-400;
    }

    &__line {
      margin: 4.8rem 0;
      border-top: 1px #C9C7CD solid;
    }

    &__content {
      :deep() {
        @include article-markdown {
          p {
            @include body-2;
            margin: 1rem 0;
          }
        }
        max-width: unset;
      }
    }
  }
</style>
